import { css } from "@emotion/react"

import { colorsCP, fontsCP } from "@mkt/cp/src/styles/Tokens"
import { getDuration } from "@mkt/cp/src/styles/Functions"
import { below, above } from "@mkt/cp/src/styles/Breakpoints"
import { animeShow } from "@mkt/ui/styles/Keyframes"

const wrapperAnimation = (valueList) => {
  const cssAnimation = {}
  valueList.forEach((item) => {
    cssAnimation[`&:nth-of-type(${item})`] = {
      animation: `${animeShow} ${getDuration(item)} 0.2s linear forwards;`,
    }
  })

  return cssAnimation
}

export const wrapper = css`
  width: 100%;
  text-decoration: none;
  opacity: 0;
  align-self: stretch;

  &:hover {
    text-decoration: none;
  }

  ${below["m"]} {
    text-align: left;
  }

  ${wrapperAnimation([1, 2, 3, 4])}
`
export const box = (expandY, borderRadius, padding) => {
  const expandHeight = css`
    height: 100%;
  `

  return  css`
    display: flex;
    flex-direction: column;

    padding: ${padding}px;
    background-color: ${colorsCP["neutral-00"]};
    border-radius: ${borderRadius}px;
    border: 1px solid ${colorsCP["neutral-20"]};

    ${above["m"]} {
      ${!!expandY && expandHeight}
    }
  `
}

export const header =  css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  cursor: pointer;

  ${above["m"]} {
    cursor: default;
  }
`

export const arrow = (isOpen) => {
  const invert = css`
    transform: rotate(-180deg);
  `

  return  css`
    margin-left: auto;
		transition: transform 0.3s ease;

    .icon {
      width: 24px;
      height: 24px;
    }

    ${above["m"]} {
      display: none;
    }

    ${isOpen && invert}
  `
}

export const content = (isOpen, divider) => {
  const noDivider = css`
    padding-top: 24px;
    margin-top: 0;
    border-top: none;
  `

  const open = css`
    padding-top: 16px;
    margin-top: 16px;
    opacity: 1;
    visibility: visible;
    max-height: 5000px;

    ${!divider && noDivider}
  `

  return  css`
    padding-top: 0px;
    margin-top: 0px;
    border-top: 1px solid ${colorsCP["neutral-20"]};

    font-family: ${fontsCP['font-primary']['font-family']};
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5;
    text-align: left;
    color: ${colorsCP["neutral-50"]};

		opacity: 0;
		max-height: 0;
		visibility: hidden;
		overflow: hidden;
		transition: max-height 0.2s ease, opacity 0.2s ease-in, padding 0.2s ease;

    a {
      font-weight: 700;
      color: ${colorsCP["blue-40"]};
      text-decoration: none;
    }

    ol, ul {
      padding-top: 24px;
      padding-left: 24px
    }

    ol li {
      list-style: decimal;
    }

    ol li p {
      display: inline;
    }

    ${isOpen && open}

    ${above["m"]} {
      ${open}
    }
  `
}
